!function() {
  "use strict";
  
  const SELECTORS = {
    hoverTarget: "[data-hover-target]",
    collectionImage: "[data-collection-image]",
    imageText: "[data-collection-image-text]",
    scrollSpyButton: "[data-scroll-spy]"
  };
  
  const CLASSES = {
    isVisible: "is-visible",
    isSelected: "is-selected"
  };
  
  const ATTRIBUTES = {
    hoverTarget: "data-hover-target"
  };
  
  customElements.get("collections-hover") || customElements.define("collections-hover", class extends HTMLElement {
    constructor() {
      super();
      
      this.buttons = this.querySelectorAll(SELECTORS.hoverTarget);
      this.imageTexts = this.querySelectorAll(SELECTORS.imageText);
      this.collectionImages = this.querySelectorAll(SELECTORS.collectionImage);
      this.scrollSpyButtons = this.querySelectorAll(SELECTORS.scrollSpyButton);
      this.observer = null;
      this.mutationObserver = null;
    }
    
    connectedCallback() {
      // Initialize hover functionality
      if (this.buttons.length) {
        this.buttons.forEach(button => {
          button.addEventListener("mouseenter", (event) => {
            const targetId = event.currentTarget.getAttribute(ATTRIBUTES.hoverTarget);
            this.updateState(targetId);
          });
        });
      }
      
      // Initialize intersection observer for image text elements (mobile stacked layout)
      this.initializeIntersectionObserver();
      
      // Initialize mutation observer for scroll-spy changes (default mobile layout) - MOBILE ONLY
      if (window.innerWidth <= 749) {
        this.initializeMutationObserver();
        // Initial opacity update
        this.updateImageOpacity();
      }
      
      // Listen for resize events to handle mobile/desktop switching
      window.addEventListener('resize', this.handleResize.bind(this));
    }
    
    handleResize() {
      if (window.innerWidth <= 749) {
        // Mobile: initialize opacity functionality if not already done
        if (!this.mutationObserver) {
          this.initializeMutationObserver();
          this.updateImageOpacity();
        }
      } else {
        // Desktop: remove opacity functionality and reset all images to full opacity
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
        }
        // Reset all images to full opacity
        this.collectionImages.forEach(image => {
          image.style.opacity = '';
        });
      }
    }
    
    initializeIntersectionObserver() {
      if (this.imageTexts.length && "IntersectionObserver" in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const target = entry.target;
            if (entry.isIntersecting) {
              target.classList.add(CLASSES.isSelected);
            } else {
              target.classList.remove(CLASSES.isSelected);
            }
          });
        }, {
          root: null,
          rootMargin: "0px",
          threshold: 0.75 // Trigger when 75% of element is visible
        });
        
        // Observe all image text elements
        this.imageTexts.forEach(imageText => {
          this.observer.observe(imageText);
        });
      }
    }
    
    initializeMutationObserver() {
      if ("MutationObserver" in window) {
        this.mutationObserver = new MutationObserver((mutations) => {
          let shouldUpdateOpacity = false;
          
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const target = mutation.target;
              if (target.matches(SELECTORS.scrollSpyButton)) {
                shouldUpdateOpacity = true;
              }
            }
          });
          
          if (shouldUpdateOpacity) {
            this.updateImageOpacity();
          }
        });
        
        // Observe class changes on scroll-spy buttons
        this.scrollSpyButtons.forEach(button => {
          this.mutationObserver.observe(button, {
            attributes: true,
            attributeFilter: ['class']
          });
        });
      }
    }
    
    updateImageOpacity() {
      // Only run on mobile
      if (window.innerWidth > 749) return;
      
      // Find the currently selected scroll-spy button
      const selectedButton = this.querySelector(`${SELECTORS.scrollSpyButton}.${CLASSES.isSelected}`);
      
      if (selectedButton) {
        const targetId = selectedButton.getAttribute("data-scroll-spy");
        if (targetId) {
          // Update opacity for all collection images
          this.collectionImages.forEach(image => {
            if (image.id === targetId.replace('#', '')) {
              // Selected image gets full opacity
              image.style.opacity = '1';
            } else {
              // Non-selected images get reduced opacity
              image.style.opacity = '0.5';
            }
          });
        }
      }
    }
    
    updateState(targetId) {
      const button = this.querySelector(`[${ATTRIBUTES.hoverTarget}="${targetId}"]`);
      const image = this.querySelector(`#${targetId}:not(.${CLASSES.isVisible})`);
      const selectedButton = this.querySelector(`${SELECTORS.hoverTarget}.${CLASSES.isSelected}`);
      const visibleImage = this.querySelector(`${SELECTORS.collectionImage}.${CLASSES.isVisible}`);
      
      if (image && !window.theme.isMobile()) {
        if (visibleImage) visibleImage.classList.remove(CLASSES.isVisible);
        if (selectedButton) selectedButton.classList.remove(CLASSES.isSelected);
        
        image.classList.add(CLASSES.isVisible);
        button.classList.add(CLASSES.isSelected);
      }
    }
    
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
      window.removeEventListener('resize', this.handleResize);
    }
  });
}();
